// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3-y7F","range":"MonthRangeSwitch_range__10JV5","disabled":"MonthRangeSwitch_disabled__3gyTW"};